//
//
//
//
//
//
//
//

import { getLocalInfo } from '../util'
export default {
  props: {
    code: String,
    holderText: String,
    routrPath: String
  },
  data () {
    return {
      sCode: ''
    }
  },
  watch: {
    code: function (val) {
      this.sCode = val
    }
  },
  methods: {
    search: function () {
      this.$emit('change', this.sCode)
    }
  },
  mounted () {
    // 刷新后从本地存储里拿上次的搜索内容
    if (this.routrPath === 'tariff' || this.routrPath === 'product') {
      let paramsCode = this.$route.params.code
      if (paramsCode) {
        this.sCode = paramsCode
      } else {
        this.sCode = getLocalInfo(this.routrPath + 'SearchCode') || ''
      }
      this.$emit('change', this.sCode)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/searchInput.vue